
import { FaShoppingBag, FaGavel, FaHandshake, FaRedo, FaStar, FaMapMarkedAlt } from "react-icons/fa";


export const ENABLE_RESONATE_WEBSITE = true;
export const HOSTURL = "https://api.nbcfonline.com";
//export const HOSTURL = "http://47.41.232.23:5000";
//export const HOSTURL = "http://localhost:5000";
export const PRODUCTS_API = HOSTURL + "/products";
export const PRODUCT_SHOP_ONLINE = PRODUCTS_API + "/type/shop-online";
export const PRODUCT_SHOP_ONLINE_OB = PRODUCTS_API + "/type/shop-online-ob";
export const PRODUCT_RESONATE_EXCLUSIVE = PRODUCTS_API + "/type/resonate-exclusives";
export const MIN_PRODUCTS_API = HOSTURL + "/min/products";
export const ORDER_API = HOSTURL + "/order";
export const AUCTION_API = HOSTURL + "/auctions";
export const AUCTION_BID_API = AUCTION_API + "/bid";
export const AUCTION_FAVORITE_API = AUCTION_API + "/favorites";
export const AUCTION_NOTIFICATION = HOSTURL + "/user/auctionnotifcation/";
export const USER_API = HOSTURL + "/user";
export const USER_EMAIL_API = USER_API + "/email/";
export const USER_CONTACT_API = USER_API + "/contact/";
export const PLEDGE_API = HOSTURL + "/pledge";
export const PLEDGE_TOTAL_API = PLEDGE_API + "/totalReceived";
export const SUBSCRIPTION_API = HOSTURL + "/subscription";
export const SUBSCRIPTION_TOTAL_API = HOSTURL + "/totalsubscriptiondetails";
export const TOKEN_API = HOSTURL + "/tokens";
export const TOKEN_HISTORY_API = HOSTURL + "/tokenHistory/user/";



export const CATEGORIES_UPDATED = {
  "/services": "Services & Games"
};

export const RESONATE_PREVIEWS = {
  "/food": "Food",
  "/snacks": "Snacks & More"
};

export const MAIN_PAGE_NAVIGATION = {
  "/shop-online": {
    title: "Shop Online",
    description: "Browse our online store to support our ministry through your purchases.",
    cta: "Visit Shop",
    icon: FaShoppingBag,
    image: "/food.png",
  },
  "/auction": {
    title: "Silent Auction",
    description: "Bid on exclusive items while supporting a great cause.",
    cta: "View Auction",
    icon: FaGavel,
    image: "/images/silent-auction.jpg",
  },
  "/pledge": {
    title: "Double Your Impact",
    description: "Double your donation with a matching gift from generous donors.",
    cta: "Double My Gift",
    icon: FaHandshake,
    image: "/images/matching-gift.jpg",
  },
  "/subscription": {
    title: "Continuous Impact",
    description: "Set up monthly donations to provide ongoing support for our ministry.",
    cta: "Make an Impact",
    icon: FaRedo,
    image: "/images/continuous-impact.jpg",
    highlight: true,
  },
  "/resonate-exclusives": {
    title: "Resonate Exclusives",
    description: "Access exclusive events and content specially curated for our community.",
    cta: "Learn More",
    icon: FaStar,
    image: "/images/resonate.jpg",
  },
  "/map": {
    title: "Event Map",
    description: "Explore the venue and find key locations easily.",
    cta: "Open Map",
    icon: FaMapMarkedAlt,
    image: "/images/event-map.jpg",
  },
};

export const ONLINE_CATEGORIES = [
  "Ethnic Wear & Accessories",
  "Kidz Korner",
  "Services & Games"
];

export const RESONATE_EXCLUSIVE_CATEGORIES = [
  "Food",
  "Snacks"
];

export const PLEDGE_AMOUNT = [50, 100, 250, 500, 1000];

export const SUBSCRIPTION_AMOUNT = ["25", "50", "100", "250", "500", "1000" ];

export const BID_VALUE_OPTIONS = [5, 25, 50, 100];

export const BIRIYANI_BAZAAR = [
  "Mutton Biriyani",
  "Fish Biriyani",
  "Veal Biriyani",
  "Chicken Biriyani",
  "Boti",
  "Crab",
  "Thala Curry",
  "Paaya"
];

export const CHAAT_CORNER = ["Bhel Puri"];

export const CRISPY_BITES = ["Punugulu"];

export const COFFEE_CORNER = [
  "BBQ Ribs",
  "Beef Kabob",
  "Chicken 65",
  "Chicken Cutlets",
  "Chicken Puffs",
  "Egg Puffs",
  "Filter Coffee",
  "Masala Vada",
  "Medhu Vada",
  "Tea",
  "Tuna Cutlets"
];

export const PAROTTA_KADAI = ["Parotta with Chicken Salna"];

export const DELIGHTFUL_DRINKS = ["Mango Lassi", "Rose Milk", "Jigarthanda"];

export const COOKIE_COUTURE = [
  "Cake Pops",
  "Caramel Flan",
  "Cookie Mix Jars",
  "Mango Custard",
  "Mango Mousse",
  "Tres Leches Cake"
];

export const BOBA_BITES = [
  "Caramel Flan",
  "Chicken Tenders",
  "Fries",
  "Mango Mousse",
  "Milk Tea with Boba",
  "Thai Tea with Boba",
  "Tres Leches"
];

export const TIFFIN_TABLE = [
  "Appam",
  "Beef Curry",
  "Chicken Curry",
  "Chicken Salna for Parotta",
  "Fish Curry",
  "Idly",
  "Idyappam",
  "Kadalai Curry",
  "Mutton Curry",
  "Parotta",
  "Puttu",
  "Sambar",
  "Veg Kurma"
];

export const SNACK_SHACK = [
  "Adhirasam",
  "Appalu Thattai",
  "Badam Halwa",
  "Badusha",
  "Beef Pickle",
  "Boondi Laddu",
  "Cashew Pagoda",
  "Coconut Burfi",
  "Ellu Podi",
  "Frozen Beef Samosa",
  "Frozen Chicken Samosa",
  "Garlic Pickle",
  "Gongura Shrimp",
  "Idly Podi",
  "Kara Sev",
  "Karuvadu",
  "King Fish Karuvadu",
  "Kumquat Pickle",
  "Macaroons",
  "Masala Kadalai",
  "Mathi Fry",
  "Mixture",
  "Murukku",
  "Mysore Pak",
  "Nei Urundai",
  "Oma Podi",
  "Paan Coconut Laddu",
  "Poli",
  "Puliyodharai Mix",
  "Ravva Laddu",
  "Ribbon Pakoda",
  "Rose Cookie",
  "Shrimp Pickle",
  "Sweet Diamond Cuts",
  "Thattai",
  "Tomato Pickle",
  "Urad Dal Laddu"
];


export const EXCLUDE_LIST = [];

/**
 * "pradeep3939@gmail.com", 
  "abishegelijah@gmail.com", 
  "anitadian@gmail.com", 
  "ebepan@gmail.com", 
  "ericacornelius22@gmail.com",
  "eva.angel30@gmail.com",
  "florence487@gmail.com",
  "hemanjk@gmail.com",
  "hoshalacornelius@gmail.com",
  "jdskumar@gmail.com",
  "jelina.rathnaraj@gmail.com",
  "jessiejude@gmail.com",
  "m.navinjoseph@gmail.com",
  "majude@gmail.com",
  "misha_david@hotmail.com",
  "mytpan@yahoo.com",
  "newmanjoseph.u@gmail.com",
  "pradeep3939@gmail.com",
  "prince.jayaraj@gmail.com",
  "roselinprince79@gmail.com",
  "rumita20@gmail.com",
  "samantajeslin@gmail.com",
  "sammyanita@gmail.com",
  "samuelandrew@hotmail.com",
  "samuelandsheila@gmail.com",
  "sheilaviolet@yahoo.com",
  "sheilavioletjohn@gmail.com",
  "steffy2988@gmail.com",
  "susipand@gmail.com",
  "thambu.daniel@gmail.com",
  "uday.ravuri@gmail.com",
  "vishcornelius@gmail.com",
  "Eli.pan24@gmail.com",
  "lizpan93@gmail.com",
  "shirleykuttyjohn@gmail.com",
  "silasejohn@gmail.com",
  "kennethdotprince@gmail.com",
  "Kemuelprince@icloud.com",
  "Rebekahsdaniel1@gmail.com",
  "Nathanirlpriyakumar@gmail.com",
  "shreyamedidha@gmail.com",
  "joelcanvas27@gmail.com",
  "amazia.amazing@gmail.com",
  "adora.adorable@gmail.com",
  "jessicacornelius23@gmail.com",
  "MabelJ.Finney@gmail.com",
  "jonathanemmanuel8@gmail.com"
 */